import { useState } from "react";
import "./carousel.css";

import banner1 from "../../assetes/Carousel/banner-1.jpg";
import banner2 from "../../assetes/Carousel/banner-2.jpg";
import banner3 from "../../assetes/Carousel/banner-3.JPG";
import banner4 from "../../assetes/Carousel/banner-4.jpeg";
import banner5 from "../../assetes/Carousel/banner-5.jpg";

import Carousel from "react-bootstrap/Carousel";
import { CiTextAlignCenter } from "react-icons/ci";

const CarouselBar = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  return (
    <>
      <div style={{ marginTop: "80px" }}>
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          style={{
            width: "100%",
            // textAlign: "center",
            marginTop: "10px",
            marginBottom: 0,
          }}
        >
          <Carousel.Item>
            <img
              src={banner1}
              alt="واحد تقطیر کارخانه پالایش اسپادانا"
              style={{ width: "100%", height: "50%" }}
            ></img>
            <Carousel.Caption className="title" sx={{ CiTextAlignCenter }}>
              <h3>واحد تقطیر کارخانه پالایش اسپادانا</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              src={banner2}
              alt="دستگاه اشمیت کارخانه تاتائو"
              style={{ width: "100%", height: "50%" }}
            ></img>
            <Carousel.Caption className="title">
              <h3>دستگاه اشمیدت کارخانه تاتائو</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              src={banner3}
              alt="سیلوی 50 تنی دشت مغان"
              style={{ width: "100%", height: "50%" }}
            ></img>
            <Carousel.Caption className="title">
              <h3>سیلوی 50 تنی دشت مغان</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              src={banner4}
              alt="واحد پرس کارخانه ایلکین"
              style={{ width: "100%", height: "50%" }}
            ></img>
            <Carousel.Caption className="title">
              <h3>واحد پرس کارخانه ایلکین</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              src={banner5}
              alt="واحد تقطیر شرکت پترو پالایش کوثر"
              style={{ width: "100%", height: "50%" }}
            ></img>
            <Carousel.Caption className="title">
              <h3>واحد تقطیر شرکت پترو پالایش کوثر</h3>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
    </>
  );
};
export default CarouselBar;
